import React from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
import { MapPin, ArrowUpRight } from 'lucide-react';
export function Location() {
  return <section id="location" className="py-20 md:py-32 px-6 md:px-12 bg-cream relative scroll-mt-16" data-id="element-159" data-mp="lv7tiafqot7m">
      <div className="max-w-6xl mx-auto" data-id="element-160" data-mp="qs7ysj4rlrxo">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-161" data-mp="qvccc744e010">
          {/* Sunset image */}
          <div className="order-2 md:order-1" data-id="element-162" data-mp="hskzc2vliw79">
            <FadeIn data-id="element-163" data-mp="hue4fdqk98d5">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-sm" data-id="element-164" data-mp="huxksq0kbop2">
                <SafeImage src="https://cdn.magicpatterns.com/uploads/6Ew4gLtza9LmKtNg4QjtwM/472670554_122134502420570946_2241759590050120448_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/ffnbPcW2MxKqF2667fz2MN/542760348_122198079770570946_2686341410234026026_n_(1).jpg" alt="Sunrise over the open fields beside Pines Retreat" className="w-full h-full object-cover" data-id="element-165" data-mp="35rrfioeosp3" />
              </div>
            </FadeIn>
          </div>

          {/* Text + actions */}
          <div className="order-1 md:order-2" data-id="element-166" data-mp="1987wy952frbi">
            <FadeIn data-id="element-167" data-mp="196wse73sqfjc">
              <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-168" data-mp="195bx2f9nqskf">
                The Location
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-169" data-mp="gjisq18pr5vj">
              <h2 className="font-serif text-3xl md:text-4xl text-pine mb-6 leading-tight" data-id="element-170" data-mp="ggo746dyrf0j">
                Near Pardes Hanna
                <br data-id="element-171" data-mp="q9c5v6oi7t1w" />/ Kfar Pines.
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-172" data-mp="qan5cuax2en7">
              <p className="text-lg text-clay font-light leading-relaxed mb-4" data-id="element-173" data-mp="lhu1s9r6pccp">
                Tucked away in nature, a short drive from Tel Aviv and Haifa. A
                hidden space designed for dropping in and slowing down.
              </p>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-174" data-mp="ihk4mrdnymib">
              <p className="text-sm text-clay/70 mb-10" data-id="element-175" data-mp="igiucp4h241n">
                ~45 min from Tel Aviv · ~30 min from Haifa
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-176" data-mp="mgszy0ocqsfz">
              <a href={LINKS.googleMaps} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 px-6 py-3.5 bg-pine text-cream rounded-sm font-medium tracking-wide hover:bg-pineDeep transition-colors" data-id="element-177" data-mp="r9m2qj09fqpf">
                <MapPin className="w-4 h-4" data-id="element-178" data-mp="3l2v85p1bhye" />
                Get Directions
                <ArrowUpRight className="w-4 h-4 opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-179" data-mp="8iuvbmzu2ado" />
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}